import { Service, signal } from '@angular/core';
import { Portal } from '@angular/cdk/portal';

/**
 * The top bar belongs to the layout; a page that needs more than its route title there hands
 * its header over through this service. Written by app-page-header, read by the layout.
 */
@Service()
export class PageHeaderService {
    private readonly current = signal<Portal<unknown> | null>(null);

    readonly portal = this.current.asReadonly();

    show(portal: Portal<unknown>): void {
        this.current.set(portal);
    }

    /**
     * Takes the header down straight away rather than on the layout's next render: the page that
     * declared it is being destroyed, and its nodes must not outlive it in the top bar.
     */
    clear(portal: Portal<unknown>): void {
        if (portal.isAttached) {
            portal.detach();
        }

        if (this.current() === portal) {
            this.current.set(null);
        }
    }
}
